import { action } from '@ember/object';
import { pluralize } from 'ember-inflector';
import { sanitizeSparseFieldsets, serializeInclude } from 'client-portal/utils/jsonapi-query';
import { service } from '@ember/service';
import FastbootHelpersMixin from 'client-portal/mixins/route/fastboot-helpers';
import Route from '@ember/routing/route';
import classic from 'ember-classic-decorator';

const ExtendedRoute = Route.extend(FastbootHelpersMixin);

@classic
export default class SiteBilling extends ExtendedRoute {
  @service router;
  @service store;
  @service session;
  @service billingModals;

  beforeModel(transition) {
    super.beforeModel(...arguments);

    this.session.requireAuthentication(transition, 'home');
    if (!this.session.currentClient.permissions.billingDocuments) {
      this.router.transitionTo('site.home');
    }
  }

  model() {
    if (this.hasShoebox) {
      return this.session.currentClient;
    } else {
      let include = [
        'clientBillingOverview',
        'unpaidInvoices',
        'cards',
        'monarchChannelClientInfos',
        'monarchChannelClientInfos.globalMonarchChannel',
        'stripeAchBankAccounts',
        'insuranceInfos',
        'phones',
        'addresses',
        'clientRelationships',
        'insuranceInfos.insurancePlan',
        'insuranceInfos.documents',
      ];

      let models = [
        'treatable-client',
        'client-billing-overview',
        'invoice',
        'card',
        'stripe-ach-bank-account',
        'global-monarch-channel',
        'monarch-channel-client-info',
        'client-relationship',
      ];

      let fields = models.reduce((acc, modelName) => {
        let model = this.store.modelFor(modelName);
        acc[pluralize(model.modelName)] = model.fieldsFor('show').join(',');
        return acc;
      }, {});

      fields = sanitizeSparseFieldsets(fields);
      include = serializeInclude(include);

      return this.session.currentClient.reload({
        adapterOptions: {
          query: {
            fields,
            include,
          },
        },
      });
    }
  }

  @action
  async refreshRequest() {
    await this.refresh();
  }

  async afterModel() {
    await this.store.query('clinician-insurance-info-review', {
      include: 'client,insuranceInfoRequestConnection,insuranceInfoRequestConnection.insurancePlan',
      page: { size: 50 },
    });
  }

  activate() {
    super.activate(...arguments);
    this.billingModals.set('afterPersist', [() => this.refresh()]);
  }
}
